<template>
  <b-modal header-bg-variant="primary" centered ref="confirmDeleteModal" id="confirmDeleteModal" size="lg" :title="$t('Confirmar borrado')" o-close-on-backdrop="true" @ok="handleDeleteModal" :ok-title="$t('Aceptar')" :cancel-title="$t('Cancelar')">
    <h4 class="text-center">{{$t('¿Esta seguro que desea eliminar el Punto de retiro seleccionado?')}}</h4>
    <br>
    <h5 class="text-center">{{$t('Punto de retiro a eliminar:')}} {{pickupPoint.name}}</h5>
  </b-modal>
</template>

<script>
import { PickupPointServiceMixin } from '@/mixims/CarrierServiceMixin.js'
export default {
  mixins: [PickupPointServiceMixin],
  props: {
    pickupPoint: {
      type: Object,
      default: null
    }
  },
  methods: {
    showConfirmModal () {
      this.$refs.confirmDeleteModal.show()
    },
    handleDeleteModal () {
      this.deletePickupPoint(this.pickupPoint.id).then(() => {
        this.$refs.confirmDeleteModal.hide()
        this.$emit('showMessage', { message: 'Punto de retiro eliminado exitosamente', variant: 'success' })
      }).catch((response) => {
        let errorMessage = 'Error al eliminar el punto de retiro'

        if (response.status === 409) {
          errorMessage = 'No se puede eliminar un punto de retiro mientras el mismo esté asociado a una transportadora.'
        }

        this.$refs.confirmDeleteModal.hide()
        this.$emit('showMessage', { message: errorMessage, variant: 'danger' })
      })
    }
  }
}
</script>

<style>

</style>